const initialState = {
};

export default function reportReducer(state = initialState, action) {
  switch (action.type) {
  case 'POST_DATA_REPORT':
    return action.data;
  case 'GET_DATA_REPORT':
    return {
      ...state,
      dataReport: action.data
    };
  case 'GET_MENU_REPORT':
      return {
        ...state,
        menu: action.data,
        pathAPI: action.pathAPI
      };
  case 'GET_DATA_BULAN_REPORT':
      return {
        ...state,
        dataBulan: action.data
      };
  case 'GET_ISLOADING_REPORT':
      return {
        ...state,
        isLoading: action.data
      };
  default:
    return state;
  }
}